/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".app-wrapper[_ngcontent-%COMP%]{background-color:#e8eaf6;height:100%}"];
export { styles as styles };
